import img2 from "../Images/hobbies/1.webp";
import img1 from "../Images/hobbies/3.webp";
import img3 from "../Images/hobbies/2.webp";
import img4 from "../Images/hobbies/4.webp";
import img5 from "../Images/hobbies/5.webp";
import img6 from "../Images/hobbies/6.webp";



export const HOBBIES = [
  { name: "Clay Art", img: img1, alt: "" },
  { name: "Art & Craft", img: img2, alt: "" },
  { name: "Mandana Art", img: img3, alt: "" },
  { name: "Creating Reels", img: img4, alt: "" },
  { name: "Writing", img: img5, alt: "" },
  { name: "Doodling", img: img6, alt: "" },
];
